import React from "react";
import {
  PictureAsPdf,
  TableChart,
  Description,
  Image,
  Videocam,
  FileCopy,
  Audiotrack,
  InsertDriveFileOutlined,
  TextSnippet,
} from "@mui/icons-material";
import { IFileExtension } from "../../FileUploadIcon/helpers";

export const fileIconMap: Record<IFileExtension, React.ReactNode> = {
  PDF: <PictureAsPdf sx={{ color: "#E53935", fontSize: 28 }} />,
  EXCEL: <TableChart sx={{ color: "#2E7D32", fontSize: 28 }} />,
  DOC: <Description sx={{ color: "#1565C0", fontSize: 28 }} />,
  IMAGE: <Image sx={{ color: "#8E24AA", fontSize: 28 }} />,
  VIDEO: <Videocam sx={{ color: "#FB8C00", fontSize: 28 }} />,
  CSV: <FileCopy sx={{ color: "#00897B", fontSize: 28 }} />,
  AUDIO: <Audiotrack sx={{ color: "#6D4C41", fontSize: 28 }} />,
  TXT: <TextSnippet sx={{ color: "#23a4ef", fontSize: 28 }} />,
  OTHER: <InsertDriveFileOutlined sx={{ color: "#616161", fontSize: 28 }} />,
};
